<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<!-- eslint-disable eslint-disable vue/no-parsing-error -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main v-if="reservationGroup != null" class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('pageReservationGroup.title.group') }} #{{ reservationGroup.confirmationNumber }}
    </portal>

    <card id="reservations" :title="$t('pageReservationGroup.card.roomReservations')" cols="12 6@tablet 8@desktop 9@hd">
      <hm-card-inner :full-size="true">
        <paginated-table id="resgrp-reservations"
                         :sticky="true"
                         :rows="reservationGroup.roomReservations"
                         :hover="true"
                         min-width="700px"
                         columns="6 11@desktop 11@hd"
                         grid-template-columns="max-content repeat(calc(var(--table-columns) - 1), auto)"
                         :items-per-page="15" >
          <template slot="table-head">
            <sortable-th field="reservationNumber">{{ $t('pageReservationGroup.reservations.reservationNumber') }}</sortable-th>
            <div class="hm-table__th">{{ $t('pageReservationGroup.reservations.name') }}</div>
            <sortable-th field="checkInDate">{{ $t('pageReservationGroup.reservations.arrivalDate') }}</sortable-th>
            <sortable-th field="checkOutDate">{{ $t('pageReservationGroup.reservations.departureDate') }}</sortable-th>
            <sortable-th field="stayDetails.numAdults" class="hidden visible@desktop">{{ $t('pageReservationGroup.reservations.numAdults') }}</sortable-th>
            <sortable-th field="stayDetails.numChildren" class="hidden visible@desktop">{{ $t('pageReservationGroup.reservations.numChildren') }}</sortable-th>
            <div class="hm-table__th hidden visible@desktop">{{ $t('pageReservationGroup.reservations.ratePlan') }}</div>
            <div class="hm-table__th hidden visible@desktop">{{ $t('pageReservationGroup.reservations.roomType') }}</div>
            <sortable-th field="stayDetails.roomNumber">{{ $t('pageReservationGroup.reservations.roomNumber') }}</sortable-th>
            <sortable-th field="status" class="hidden visible@desktop">{{ $t('pageReservationGroup.reservations.status') }}</sortable-th>
            <div class="hm-table__th"></div>
          </template>
          <template v-slot:default="slotProps">
            <template v-for="res in slotProps.currentPage">
              <div class="hm-table__td" @click="openReservation(res.reservationId)">{{ res.reservationNumber }}</div>
              <div class="hm-table__td privacy--blur" @click="openReservation(res.reservationId)">{{ res.stayDetails.displayName }}</div>
              <div class="hm-table__td" @click="openReservation(res.reservationId)">{{ res.checkInDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td" @click="openReservation(res.reservationId)">{{ res.checkOutDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td hidden visible@desktop" @click="openReservation(res.reservationId)">{{ res.stayDetails.numAdults }}</div>
              <div class="hm-table__td hidden visible@desktop" @click="openReservation(res.reservationId)">{{ res.stayDetails.numChildren }}</div>
              <div class="hm-table__td hidden visible@desktop" @click="openReservation(res.reservationId)">{{ findHotelSettingById('ratePlans', res.stayDetails.ratePlanId).name[$shortLocale] }}</div>
              <div class="hm-table__td hidden visible@desktop" @click="openReservation(res.reservationId)">{{ findHotelSettingById('roomTypes', res.stayDetails.roomTypeId).name[$shortLocale] }}</div>
              <div class="hm-table__td" @click="openReservation(res.reservationId)">{{ res.stayDetails.roomNumber }}</div>
              <div class="hm-table__td hidden visible@desktop" @click="openReservation(res.reservationId)">{{ $t(`ReservationStatus.${res.status}`) }}</div>
              <div class="hm-table__td hm-table__td--no-hover hm-table__td--icon">
                <template v-if="canEdit">
                  <span v-tooltip="{ title: $t('pageReservationGroup.reservations.cancelReservation'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }" v-if="res.status === 'NonGuaranteed' || res.status === 'Guaranteed' || res.status === 'AwaitingPayment'" class="quick-action-button" @click="cancelReservation(res.reservationId)">
                    <icon icon="delete" />
                  </span>
                  <span v-tooltip="{ title: $t('pageReservationGroup.reservations.checkIn'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }" v-if="res.status === 'NonGuaranteed' || res.status === 'Guaranteed' || res.status === 'AwaitingPayment'" class="quick-action-button" @click="reservationAction(res.reservationId, 'checkIn')">
                    <icon icon="checkin" />
                  </span>
                  <span v-tooltip="{ title: $t('pageReservationGroup.reservations.undoCheckIn'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }" v-if="res.status === 'InHouse'" class="quick-action-button" @click="reservationAction(res.reservationId, 'undoCheckIn')">
                    <icon icon="undo" />
                  </span>
                  <span v-tooltip="{ title: $t('pageReservationGroup.reservations.checkOut'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }" v-if="res.status === 'InHouse'" class="quick-action-button" @click="reservationAction(res.reservationId, 'checkOut')">
                    <icon icon="checkout" />
                  </span>
                </template>
              </div>
            </template>
          </template>
        </paginated-table>
      </hm-card-inner>
    </card>


    <card id="booker" :title="$t('pageReservationGroup.card.booker')" cols="12 6@tablet 4@desktop 3@hd" rows="3">
      <guest-profile-editor id="booker" v-model="reservationGroup.booker.guestProfileId" :search-disabled="!canEdit" type="Guest" />
    </card>

    <card :title="$t('pageReservationGroup.card.general')" cols="12 6@tablet 4@desktop 3@hd start-1">
      <hm-card-inner :title="$t('pageReservationGroup.card.group')">
        <hm-input :value="reservationGroup.confirmationNumber" :disabled="true" :label="$t('pageReservationGroup.confirmationNumber')" name="confirmationNumber" />
        <hm-input v-model="reservationGroup.name" :label="$t('pageReservationGroup.groupName')" :disabled="!canEdit" name="groupName" />
        <hm-input v-if="!isEmpty(reservationGroup.meldeblattURL)" :value="reservationGroup.meldeblattURL" :disabled="true" :label="$t('pageReservationGroup.meldeblattURL')">
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button :border="true" :title="$t('pageReservationGroup.copyToClipboard')" icon="copy" @click="$copy(reservationGroup.meldeblattURL)" />
          </template>
        </hm-input>
      </hm-card-inner>
      <hm-card-inner :title="$t('pageReservationGroup.card.countByRoomTypeAndCancelled')">
        <spinner-overlay v-if="stats === null" />
        <hm-card-inner v-if="stats !== null">
          <label-value-dotted v-for="(row, key) in stats" :value="row.length" :label="findHotelSettingById('roomTypes', key).name[$shortLocale]" :key="key" />
        </hm-card-inner>
      </hm-card-inner>
    </card>

    <card v-if="canEdit" id="common-fields" :title="$t('pageReservationGroup.card.editAllReservations')" cols="12 6@tablet 4@desktop 3@hd">
      <hm-card-inner :title="$t('pageReservationGroup.shortInternalComment')">
        <hm-input v-model="commonValues.shortInternalComment"
                  :maxlength="5"
                  :disabled="!commonValues.enabledShortInternalComment"
                  :label="$t('pageReservationGroup.shortInternalComment')"
                  :help="$t('pageReservationGroup.shortInternalComment_help')"
                  name="shortInternalComment"
                  cols="12 7@tablet"
                  rows="start-3@mobile" />
        <hm-input-toggle v-model="commonValues.enabledShortInternalComment"
                         :label="$t('pageReservationGroup.enabledShortInternalComment')"
                         :help="$t('pageReservationGroup.enabledShortInternalComment_help')"
                         cols="12 5@tablet"
                         rows="start-2@mobile" />
      </hm-card-inner>
      <hm-card-inner :title="$t('pageReservationGroup.requestExpirationDate')">
        <hm-input-date v-model="commonValues.requestExpirationDate"
                       :required="false"
                       :disabled="!commonValues.enabledRequestExpirationDate"
                       :label="$t('pageReservationGroup.requestExpirationDate')"
                       :help="$t('pageReservationGroup.requestExpirationDate_help')"
                       name="requestExpirationDate"
                       cols="12 7@tablet"
                       rows="start-3@mobile" />
        <hm-input-toggle v-model="commonValues.enabledRequestExpirationDate"
                         :label="$t('pageReservationGroup.enabledRequestExpirationDate')"
                         :help="$t('pageReservationGroup.enabledRequestExpirationDate_help')"
                         cols="12 5@tablet"
                         rows="start-2@mobile" />
      </hm-card-inner>
      <hm-card-inner :title="$t('pageReservationGroup.roomChargeInvoiceRecipientId')">
        <guest-search :required="false"
                      v-model="commonValues.roomChargeInvoiceRecipientId"
                      :disabled="!commonValues.enabledRoomChargeInvoiceRecipientId"
                      :label="$t('pageReservationGroup.roomChargeInvoiceRecipientId')"
                      :help="$t('pageReservationGroup.roomChargeInvoiceRecipientId_help')"
                      cols="12 7@tablet"
                      rows="start-3@mobile" />
        <hm-input-toggle v-model="commonValues.enabledRoomChargeInvoiceRecipientId"
                         :label="$t('pageReservationGroup.enabledRoomChargeInvoiceRecipientId')"
                         :help="$t('pageReservationGroup.enabledRoomChargeInvoiceRecipientId_help')"
                         cols="12 5@tablet"
                         rows="start-2@mobile" />
      </hm-card-inner>
      <hm-card-inner :title="$t('pageReservationGroup.colorCategoryCssClass')">
        <hm-reservation-color-picker v-model="commonValues.colorCategoryCssClass"
                                     :disabled="!commonValues.enabledColorCategoryCssClass"
                                     :label="$t('pageReservationGroup.colorCategoryCssClass')"
                                     name="colorCategoryCssClass"
                                     cols="12 7@tablet"
                                     rows="start-3@mobile" />
        <hm-input-toggle v-model="commonValues.enabledColorCategoryCssClass"
                         :label="$t('pageReservationGroup.enabledColorCategoryCssClass')"
                         :help="$t('pageReservationGroup.enabledColorCategoryCssClass_help')"
                         cols="12 5@tablet"
                         rows="start-2@mobile" />
      </hm-card-inner>
    </card>

    <card v-if="hasLicense('InterfaceMeldeblatt')"
          id="meldeblaetter"
          :center="isEmpty(meldeblaetter)"
          :title="$t('pageReservationGroup.card.meldeblaetter')"
          cols="12 6@tablet 4@desktop 3@hd">
      <hm-col :key="meldeblattKey" cols="12">
        <hm-card-inner v-if="isEmpty(meldeblaetter)">
          <card-action :title="$t('pageReservationGroup.cardActionCreateMeldeblatt')" @click="createMeldeblatt()" />
        </hm-card-inner>
        <hm-card-inner v-else :full-size="true">
          <hm-table :hover="true" columns="5" min-width="450px">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('pageReservationGroup.meldeblaetter.meldeblattNumber') }}</div>
              <div class="hm-table__th">{{ $t('pageReservationGroup.meldeblaetter.arrivalDate') }}</div>
              <div class="hm-table__th">{{ $t('pageReservationGroup.meldeblaetter.departureDate') }}</div>
              <div class="hm-table__th">{{ $t('pageReservationGroup.meldeblaetter.numPersons') }}</div>
              <div class="hm-table__th">{{ $t('pageReservationGroup.meldeblaetter.status') }}</div>
            </template>
            <template slot="default">
              <template v-for="row in meldeblaetter">
                <template v-if="row.status !== 'Deleted' || hasRole('ROLE_SYSADMIN')">
                  <div class="hm-table__td" @click="openMeldeblatt(row.id)">{{ row.meldeblattNummer <= 0 ? '-' : row.meldeblattNummer }}</div>
                  <div class="hm-table__td" @click="openMeldeblatt(row.id)">{{ row.anreise | toDate }}</div>
                  <div class="hm-table__td" @click="openMeldeblatt(row.id)">{{ row.abreise | toDate }}</div>
                  <div class="hm-table__td" @click="openMeldeblatt(row.id)">{{ row.guestCount }}</div>
                  <div v-if="row.anreise === row.abreise" class="hm-table__td" @click="openMeldeblatt(row.id)">{{ $t('MeldeStatus.Cancelled') }}</div>
                  <div v-else class="hm-table__td" @click="openMeldeblatt(row.id)">{{ $t(`MeldeStatus.${row.status}`) }}</div>
                </template>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
      </hm-col>
    </card>

    <template v-for="(group, key, idx) in groupedReservations">
      <card :id="`roomgroup-${idx}`" :title="$t('pageReservationGroup.card.reservationGroup', { idx: idx+1 })" :key="key" cols="12 6@tablet 4@desktop 3@hd">
        <hm-card-inner>
          <hm-input :disabled="true"
                    :value="findHotelSettingById('roomTypes', group[0].stayDetails.roomTypeId).name[$shortLocale]"
                    :label="$t('pageReservationGroup.roomTypeId')"
                    name="roomTypeId"
                    hidden="mobile" />
          <hm-input :disabled="true"
                    :value="findHotelSettingById('ratePlans', group[0].stayDetails.ratePlanId).name[$shortLocale]"
                    :label="$t('pageReservationGroup.ratePlanId')"
                    name="ratePlanId"
                    hidden="mobile" />
          <hm-input :disabled="true"
                    :value="group.length"
                    :label="$t('pageReservationGroup.roomCount')"
                    name="roomCount"
                    hidden="mobile" />
                    <!--
          <hm-input-money v-model="group[0].stayDetails.discount.percentage" name="discount" currency="%"
                          cols="12 6@tablet" label="Rabatt">
          </hm-input-money>
          <hm-input-money v-model="group[0].prepayment.amount" :currency="hotelSettings.details.currency" name="prepaymentAmount"
                          help="Anzahlungsbetrag je Zimmerreservierung"
                          cols="12 6@tablet" label="Anzahlungsbetrag">
          </hm-input-money>
          -->
        </hm-card-inner>
      </card>
    </template>


    <hm-floating-buttons ref="floatingButtons">
      <hm-floating-button :label="$t('pageReservationGroup.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button v-if="hasLicense('InterfaceMeldeblatt')"
                                  :label="$t('pageReservationGroup.actions.createMeldeblatt')"
                                  icon="plus"
                                  color="blue"
                                  @click="createMeldeblatt()" />
        <hm-floating-child-button v-if="canEdit"
                                  :label="$t('pageReservationGroup.actions.addRoomReservationToGroup')"
                                  icon="plus"
                                  color="blue"
                                  @click="createReservation()" />
      </hm-floating-button>
      <hm-floating-button :label="$t('pageReservationGroup.actions.createEmail')" icon="send-email" color="blue" @click="$router.push({ name: 'reservationGroupEmail', params: { hotelId: $route.params.hotelId, confirmationNumberOrReservationGroupId: reservationGroup.confirmationNumber }})" />
    </hm-floating-buttons>

  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  groupBy, isArray, isEmpty, isNil, last, uniq,
} from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import uuid from 'uuid';
import HmCardInner from '../lib/layout/HmCardInner';
import TimerMixin from '../../mixins/TimerMixin';

export default {
  name: 'PageReservationGroup',
  components: { HmCardInner },
  mixins: [HotelmeisterMixin, SaveWatchMixin, TimerMixin],

  autosave: [
    {
      name: 'reservationGroup',
      variable: 'reservationGroup',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.reservationGroup.get(this, this.confirmationNumberOrReservationGroupId), this.reservationGroup)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
      include: ['name', 'booker.guestProfileId'],
    },
    {
      name: 'reservationGroupReservations',
      variable: 'commonValues',
      fn: function (cbSaveComplete) {
        const update = {};

        if (this.commonValues.enabledShortInternalComment === true) {
          update.shortInternalComment = this.commonValues.shortInternalComment;
        }

        if (this.commonValues.enabledRequestExpirationDate === true) {
          update.requestExpirationDate = this.commonValues.requestExpirationDate;
        }

        if (this.commonValues.enabledRoomChargeInvoiceRecipientId === true) {
          update.roomChargeInvoiceRecipientId = this.commonValues.roomChargeInvoiceRecipientId;
        }

        if (this.commonValues.enabledColorCategoryCssClass === true) {
          update.colorCategoryCssClass = this.commonValues.colorCategoryCssClass;
        }

        this.axios.patch(this.serviceUrls.reservationGroup.updateReservations(this, this.confirmationNumberOrReservationGroupId), update)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      reservationGroup: null,
      stats: null,
      groupedReservations: null,
      commonValues: {
        shortInternalComment: null,
        requestExpirationDate: null,
        roomChargeInvoiceRecipientId: null,
        colorCategoryCssClass: null,
        enabledShortInternalComment: false,
        enabledRequestExpirationDate: false,
        enabledRoomChargeInvoiceRecipientId: false,
        enabledColorCategoryCssClass: false,
      },
      meldeblaetter: [],
      meldeblattKey: uuid.v4(),
      skipConfirmCancelDialog: false,
      confirmationNumberOrReservationGroupId: null,
    };
  },

  computed: {
    canEdit: function () {
      return this.hasAnyRole(['ROLE_RESERVATION_REQUEST', 'ROLE_RESERVATION_NOTIFICATION', 'ROLE_ADMIN', 'ROLE_SYSADMIN']);
    },
  },

  watch: {
  },

  created: function () {
    this.confirmationNumberOrReservationGroupId = this.$route.params.confirmationNumberOrReservationGroupId;
    this.updateReservationGroup();

    this.$serviceBus.$on('help.show', this.showHelp);
  },

  methods: {
    showHelp() {
      this.$driver.defineSteps([
        {
          element: '#reservations',
          popover: {
            title: 'Reservierungen',
            description: 'Alle Reservierungen, unter der gleichen Bestätigungsnummer, im Überblick. Mehrere Reservierungen können ganz einfach durch den Klick auf die entsprechenden Knöpfe (rechts) ein- oder ausgecheckt werden.',
            position: 'bottom',
            offset: 100,
          },
        },
        {
          element: '#common-fields',
          popover: {
            title: 'Gemeinsame Felder',
            description: 'Hier können Sie bestimmte Felder für alle Zimmerreservierungen, einer Gruppe, gemeinsam bearbeiten.',
            position: 'top',
            offset: 100,
          },
        },
        {
          element: '#meldeblaetter',
          popover: {
            title: 'Meldeblatt',
            description: 'Wenn Sie ein Meldeblatt auf der Gruppenreservierung erstellen, so ist dies mit allen Reservierungen dieser Gruppe verknüpft und die Daten der einzelnen Zimmerreservierungen werden direkt ins gemeinsame Meldeblatt eingetragen.',
            position: 'top',
            offset: 100,
          },
        },
        {
          element: '#roomgroup-0',
          popover: {
            title: 'Zimmergruppe',
            description: 'Reservierungen mit gleichem Tarif, gleichem Zimmertyp, gleicher Personenanzahl und gleichem An- und Abreisdatum werden zu Gruppen zusammengefasst.<br/><br/>So sehen Sie z.B. bei einer großen Gruppe schnell, dass diese z.B. 7 Doppelzimmer mit je 2 Erwachsenen, 5 Doppelzimmer mit je 1 Erwachsenen und 2 Dreibettzimmer mit 2 Erwachsenen und 1 Kind gebucht hat.',
            position: 'top',
            offset: 100,
          },
        },
        {
          element: '#booker',
          popover: {
            title: 'Bucher',
            description: 'Alle Zimmerreservierungen einer Gruppe sind auch mit dem Gästeprofil des Buchers verknüpft - d.h. Sie können die Reservierungen auch über das Gästeprofil des Buchers wiederfinden und aufrufen.',
            position: 'left',
            offset: 100,
          },
        },
      ]);
      this.$driver.start();
    },
    createReservation() {
      this.$router.push({
        name: 'createReservation',
        params: {
          confirmationNumber: this.reservationGroup.confirmationNumber,
          checkInDate: this.reservationGroup.roomReservations[0].checkInDate,
          checkOutDate: this.reservationGroup.roomReservations[0].checkOutDate,
        },
      });
    },
    createMeldeblatt(force = false, open = false) {
      const activeMeldeblaetter = this.meldeblaetter
        .filter(it => it.status !== 'Deleted')
        .length;

      if (force === false && activeMeldeblaetter > 0) {
        this.showModal(
          this.$t('pageReservationGroup.confirmMeldeblattAlreadyExists'),
          () => {
            this.createMeldeblatt(true);
          },
        );
      } else {
        this.axios.post(this.serviceUrls.meldeblatt.findByConfirmationNumber(this, this.reservationGroup.confirmationNumber))
          .then((response) => {
            if (open === true && (!isArray(response.data.data) || response.data.data.length === 1)) {
              this.openMeldeblatt(response.data.data);
            } else {
              // delayed because RYOW (read your own write) wasn't fully working because we N1QL refKey index wasn't updated yet
              this.setTimeout(() => {
                this.updateMeldeblaetter();
                this.showSuccessMessage();
              }, 250);
            }
          });
      }
    },
    openMeldeblatt(meldeblattId) {
      this.$router.push({
        name: 'meldeblatt',
        params: {
          meldeblattId: meldeblattId,
        },
      });
    },
    updateMeldeblaetter(validate = true) {
      if (!this.hasLicense('InterfaceMeldeblatt')) return;

      this.axios.get(this.serviceUrls.meldeblatt.findByConfirmationNumber(this, this.reservationGroup.confirmationNumber))
        .then((response) => {
          this.meldeblaetter = response.data.data;

          this.meldeblattKey = uuid.v4();
        });
    },
    openReservation(reservationId) {
      this.$router.push({ name: 'reservation', params: { reservationId: reservationId } });
    },
    updateReservationGroup() {
      this.axios.get(this.serviceUrls.reservationGroup.get(this, this.confirmationNumberOrReservationGroupId))
        .then((response) => {
          this.reservationGroup = response.data.data;
          if (isNil(this.reservationGroup.booker)) {
            this.reservationGroup.booker = {
              guestProfileId: null,
            };
          }
          this.updateMeldeblaetter();
          this.updateStats();
          this.updateGrouped();
          this.updateCommon();
        });
    },
    updateStats() {
      this.stats = groupBy(
        this.reservationGroup.roomReservations
          .filter(it => it.status !== 'Initial' && it.status !== 'Cancelled' && it.status !== 'NoShow' && it.status !== 'CreationFailed' && it.status !== 'RequestExpired')
          .map(it => ({
            roomTypeId: it.stayDetails.roomTypeId,
          })),
        'roomTypeId',
      );
    },
    updateGrouped() {
      this.groupedReservations = groupBy(
        this.reservationGroup.roomReservations
          .filter(it => it.status !== 'Initial' && it.status !== 'Cancelled' && it.status !== 'NoShow' && it.status !== 'CreationFailed' && it.status !== 'RequestExpired')
          .map(it => ({
            ...it,
            key: `${it.checkInDate}::${it.checkOutDate}::${it.stayDetails.roomTypeId}::${it.stayDetails.ratePlanId}::${it.stayDetails.numAdults}::${it.stayDetails.numChildren}::${Object.values(it.stayDetails.childAgeCategories)}`,
          })),
        'key',
      );
    },
    updateCommon() {
      this.as__pauseAutosave('reservationGroupReservations');

      const uniqShortInternalComments = uniq(
        this.reservationGroup.roomReservations
          .map(it => it.shortInternalComment),
      );
      if (!isNil(uniqShortInternalComments) && uniqShortInternalComments.length === 1) {
        this.commonValues.shortInternalComment = uniqShortInternalComments[0];
        this.commonValues.enabledShortInternalComment = false;
      } else {
        this.commonValues.shortInternalComment = null;
        this.commonValues.enabledShortInternalComment = false;
      }

      const uniqRequestExpirationDates = uniq(
        this.reservationGroup.roomReservations
          .map(it => it.requestExpirationDate),
      );
      if (!isNil(uniqRequestExpirationDates) && uniqRequestExpirationDates.length === 1) {
        this.commonValues.requestExpirationDate = uniqRequestExpirationDates[0];
        this.commonValues.enabledRequestExpirationDate = false;
      } else {
        this.commonValues.requestExpirationDate = null;
        this.commonValues.enabledRequestExpirationDate = false;
      }

      const uniqColorCategoryCssClasss = uniq(
        this.reservationGroup.roomReservations
          .map(it => it.colorCategoryCssClass),
      );
      if (!isNil(uniqColorCategoryCssClasss) && uniqColorCategoryCssClasss.length === 1) {
        this.commonValues.colorCategoryCssClass = uniqColorCategoryCssClasss[0];
        this.commonValues.enabledColorCategoryCssClass = false;
      } else {
        this.commonValues.colorCategoryCssClass = null;
        this.commonValues.enabledColorCategoryCssClass = false;
      }

      const uniqRoomChargeInvoiceRecipientIds = uniq(
        this.reservationGroup.roomReservations
          .map(it => it.stayDetails.roomChargeInvoiceRecipientId),
      );
      if (!isNil(uniqRoomChargeInvoiceRecipientIds) && uniqRoomChargeInvoiceRecipientIds.length === 1) {
        this.commonValues.roomChargeInvoiceRecipientId = uniqRoomChargeInvoiceRecipientIds[0];
        this.commonValues.enabledRoomChargeInvoiceRecipientId = false;
      } else {
        this.commonValues.roomChargeInvoiceRecipientId = null;
        this.commonValues.enabledRoomChargeInvoiceRecipientId = false;
      }

      this.as__continueAutosave('reservationGroupReservations');
    },
    id2number: function (value) {
      if (isEmpty(value)) return '';
      return last(value.split('::'));
    },
    cancelReservation(reservationId) {
      if (this.skipConfirmCancelDialog === true) {
        this.reservationAction(reservationId, 'cancel');
      } else {
        this.showModal(
          this.$t('pageReservationGroup.confirmCancellation', { reservationNumber: this.id2number(reservationId) }),
          (doNotShowAgain) => { this.skipConfirmCancelDialog = doNotShowAgain; this.reservationAction(reservationId, 'cancel'); },
          null,
          null,
          this.$t('pageReservationGroup.modalCancellationConfirmationDoNotAskAgain'),
        );
      }
    },
    reservationAction(reservationId, reservationAction) {
      this.$store.commit('save/started', reservationId);
      this.axios.post(this.serviceUrls.reservation.action(this, reservationId, reservationAction))
        .then((response) => {
          this.showSuccessMessage();
          this.$store.commit('save/finished', reservationId);
          this.updateReservationGroup();
        })
        .catch((error) => {
          this.$store.commit('save/finished', reservationId);
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/pages/PageReservationGroup.vue